<template>
  <div class="single-choice">
    <div class="content-stem">
      <span class="ques-num">{{ idx + 1 }}</span>
      <span v-html="currentQuestion.smallContent[idx].content"/>
    </div>
    <div class="content-list">
      <div class="content-option" v-for="(option, index) in currentQuestion.smallContent[idx].optionList" :key="index">
        <label>
          <input type="radio"
                 :name="'singleQuestion_'+idx"
                 :value="option.quesValue"
                 :checked="hasAns(option.quesValue)"
                 @click="radioToggleFn">
          <i></i>
          <strong>{{ option.quesValue }}.&nbsp;</strong>
          <span v-html="option.quesOption"/>
        </label>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  name: 'ExamSingleChoiceSimple',
  props: {
    idx: {
      type: Number
    }
  },
  data() {
    return {}
  },
  mounted() {
  },
  computed: {
    ...mapGetters([
      'currentQuestion',
      'currentQuestionIndex'
    ])
  },
  methods: {
    hasAns(old) {
      let userAns = this.currentQuestion.smallContent[this.idx].userAnswer
      let flag = false
      if (userAns && userAns === old) {
        flag = true
      }
      return flag
    },
    radioToggleFn(e) {
      this.$nextTick(() => {
        let value = this.currentQuestion.smallContent[this.idx].userAnswer === e.target.value ? '' : e.target.value
        let isAnswer = value ? 1 : 0
        const data = {
          userAnswer: value,
          index: this.idx,
          isAnswer
        }
        this.$store.dispatch('setShortAns', data)
        this.$store.dispatch('setAttIsAns', data)

        let isAnswer_big = this.currentQuestion.smallContent.some(item => {
          return item.isAnswer === 1
        })
        if (isAnswer_big) {
          this.$store.dispatch('setIsAns', 1)
        } else {
          this.$store.dispatch('setIsAns', 0)
        }
      })
    }
  }
}
</script>
